import { GetAccountResponse } from '../../types/accounts/accounts.types';

// Action type constants
export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAILURE = 'GET_ACCOUNT_FAILURE';
export const INVITE_USER_TO_ACCOUNT_REQUEST = 'INVITE_USER_TO_ACCOUNT_REQUEST';
export const INVITE_USER_TO_ACCOUNT_SUCCESS = 'INVITE_USER_TO_ACCOUNT_SUCCESS';
export const INVITE_USER_TO_ACCOUNT_FAILURE = 'INVITE_USER_TO_ACCOUNT_FAILURE';
export const CLEAR_ACCOUNT_STATE = 'CLEAR_ACCOUNT_STATE';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

// Action interfaces
export interface GetAccountRequestAction {
  type: typeof GET_ACCOUNT_REQUEST;
  [key: string]: any;
}

export interface GetAccountSuccessAction {
  type: typeof GET_ACCOUNT_SUCCESS;
  payload: GetAccountResponse;
  [key: string]: any;
}

export interface GetAccountFailureAction {
  type: typeof GET_ACCOUNT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface InviteUserToAccountRequestAction {
  type: typeof INVITE_USER_TO_ACCOUNT_REQUEST;
  payload: {
    email: string;
    firstName: string;
    lastName: string;
    role: 'admin' | 'member';
    permissions: {
      type: 'all' | 'custom';
      workspaceRole?: 'admin' | 'member';
      workspaces?: { [workspaceId: string]: string };
    };
  };
  [key: string]: any;
}

export interface InviteUserToAccountSuccessAction {
  type: typeof INVITE_USER_TO_ACCOUNT_SUCCESS;
  payload: string;
  [key: string]: any;
}

export interface InviteUserToAccountFailureAction {
  type: typeof INVITE_USER_TO_ACCOUNT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearAccountStateAction {
  type: typeof CLEAR_ACCOUNT_STATE;
  [key: string]: any;
}

export interface DeleteUserRequestAction {
  type: typeof DELETE_USER_REQUEST;
  payload: string; // userId
  [key: string]: any;
}

export interface DeleteUserSuccessAction {
  type: typeof DELETE_USER_SUCCESS;
  payload: string; // message
  [key: string]: any;
}

export interface DeleteUserFailureAction {
  type: typeof DELETE_USER_FAILURE;
  payload: string; // error message
  [key: string]: any;
}

export interface UpdateUserRequestAction {
  type: typeof UPDATE_USER_REQUEST;
  payload: {
    userId: string;
    data: {
      firstName: string;
      lastName: string;
      email: string;
      role: 'admin' | 'member';
      permissions: {
        type: 'all' | 'custom';
        workspaceRole?: 'admin' | 'member';
        workspaces?: { [workspaceId: string]: string };
      };
    };
  };
  [key: string]: any;
}

export interface UpdateUserSuccessAction {
  type: typeof UPDATE_USER_SUCCESS;
  payload: string; // message
  [key: string]: any;
}

export interface UpdateUserFailureAction {
  type: typeof UPDATE_USER_FAILURE;
  payload: string; // error message
  [key: string]: any;
}

// Union type for all account actions
export type AccountActionTypes =
  | GetAccountRequestAction
  | GetAccountSuccessAction
  | GetAccountFailureAction
  | InviteUserToAccountRequestAction
  | InviteUserToAccountSuccessAction
  | InviteUserToAccountFailureAction
  | ClearAccountStateAction
  | DeleteUserRequestAction
  | DeleteUserSuccessAction
  | DeleteUserFailureAction
  | UpdateUserRequestAction
  | UpdateUserSuccessAction
  | UpdateUserFailureAction;
